import { user } from '../../utils';
import { UserFollowEvent } from '../../Shared/events';
import { UserFollowBIModel } from '../models';
import { track } from '../../tracking/bi-track';

export const userFollowBIEventListener = () => {
    document.addEventListener(UserFollowEvent.eventType, (userFollowEvent) => {
        const userFollowBIModel = UserFollowBIModel.createFromDomainEvent(user.id, userFollowEvent);
        track(userFollowBIModel);
    });
};